import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './signUp.module.scss';

interface PasswordGuidelinesProps {
  showPasswordError: boolean;
}
export function PasswordGuidelines({
  showPasswordError,
}: PasswordGuidelinesProps) {
  const { t } = useTranslation();
  return (
    <>
      {showPasswordError && (
        <div className={styles.passwordRequirementsContainer}>
          <span>{t('auth.PASSWORD_GUIDELINES_1')}</span>
          <span>{t('auth.PASSWORD_GUIDELINES_2')}</span>
          <span>{t('auth.PASSWORD_GUIDELINES_3')}</span>
          <span>{t('auth.PASSWORD_GUIDELINES_4')}</span>
        </div>
      )}
    </>
  );
}
